import { sourceService } from '../../helpers/services/productSource.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, sessionHelper } from '@/utils'
import { SESSION } from "@/constants";
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUCT_SOURCE_MODULE = 'productSource'; 

// define action 
export const GET_ALL_PRODUCT_SOURCES = 'getAllProductSources';
export const GET_PRODUCT_SOURCE = 'getProductSource';
export const UPDATE_PRODUCT_SOURCE = 'updateProductSource';
export const CREATE_PRODUCT_SOURCE = 'createProductSource';
export const UPDATE_PRODUCT_SOURCE_STATUS = 'updateProductSourceStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCT_SOURCES_REQUEST = "getAllProductSources";
const GET_PRODUCT_SOURCE_REQUEST = "getProductSource";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCT_SOURCES]({ commit }, { filter }) {
        await sourceService
            .getAllSources(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCT_SOURCES_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT_SOURCE]({ commit }, { id }) {
        sourceService
            .getSource(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_SOURCE_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_SOURCE]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        sourceService
            .updateSource(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.productSource')]);
                    if(isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_SOURCE]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        sourceService
            .createSource(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)

                    var message = i18n.t("message.createXSuccess", [i18n.t('module.productSource')]);
                    if(isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_SOURCE_STATUS]({ dispatch }, { filter, data }) {
        sourceService
            .updateSourceStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCT_SOURCES, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state, isCloseWhenSuccess) {
        state.status = {};
        if(isCloseWhenSuccess == false) {
            router.push({ name: "Product-source-listing" });
        }
        else {
            sessionHelper.clearSearch(SESSION.PRODUCT_SPECIAL_SEARCH)
        }
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCT_SOURCES_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                source: o.source,
                product: o.product,
                isActive: o.is_active,
                remark: o.remark,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRODUCT_SOURCE_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            source: o.source,
            product: o.product,
            isActive: o.is_active,
            remark: o.remark,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            productID: o.product != null ? {
                value: o.product.uuid,
                text: o.product.name
            } : '',
            sourceID: o.source != null ? {
                value: o.source.uuid,
                text: o.source.name
            } : '',
        }

    }
}


